<!--
 * @Description: In User Settings Edit
 * @Author: laikt
 * @LastEditors: laikt
 * @Date: 2019-04-04 08:59:30
 * @LastEditTime: 2019-04-04 09:42:23
 -->
<template>
  <div id="app">
    <TheHeader />
    <div class="container">
      <router-view></router-view>
    </div>
    <TheFooter v-show="showed" />
    <OnlineService v-show="show" />
  </div>
</template>
<script>
import { menuqueryaddressid } from "@/api/menu";
import { getHomeCenterUser, getUserInfo, test111 } from "@/api/homePage";
import TheHeader from "@/components/index/TheHeader";
import TheFooter from "@/components/index/TheFooter";
import OnlineService from "@/components/index/OnlineService";
// import { mapGetters } from "vuex";
// import { getLoginUrl } from "@/api/login";
// import { mapGetters } from "vuex";
export default {
  components: {
    TheHeader,
    TheFooter,
    OnlineService,
  },
  name: "app",
  data() {
    return { show: false, showed: false };
  },
  computed: {
    // ...mapGetters(["saveUser"])
  },
  mounted() {
    if (window.location.href.indexOf("token") > -1) {
      let urlstr = this.getUrl("token");
      sessionStorage.setItem("token", urlstr);
      window.location.href = window.location.href.replace(
        "token=" + urlstr,
        ""
      );
    }
    window.addEventListener("message", this.queryUser);
    window.addEventListener("scroll", this.handleScroll);
    this.queryUser();
    function checkIE() {
      return (
        "-ms-scroll-limit" in document.documentElement.style &&
        "-ms-ime-align" in document.documentElement.style
      );
    }
    if (checkIE()) {
      window.addEventListener(
        "hashchange",
        () => {
          var currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath);
          }
        },
        false
      );
    }
  },
  created() {
    this.handleScroll();
    setTimeout(() => {
      this.showed = true;
    }, 300);
  },
  methods: {
    getUrl(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },
    handleScroll() {
      let scrollY = window.scrollY || window.pageYOffset;
      // console.log(scrollY);
      if (this.$route.path === "/") {
        if (scrollY > 200) {
          this.show = true;
        } else {
          this.show = false;
        }
      } else {
        this.show = true;
      }
    },
    queryUser() {
      let MenuQueryDto = { name: "用户接口", sign: "1" };
      menuqueryaddressid(MenuQueryDto).then((res) => {
        if (res.status === 2000) {
          sessionStorage.removeItem("userInfoView");
          sessionStorage.removeItem("userInfo");
          // debugger;
          let self = this;
          getUserInfo(res.data.routAddress)
            .then((res) => {
              if (res.status == 2000) {
                // 加注释 测试
                self.$store.dispatch("saveUser", res.data);
                // let sesssiondata = { phoneNumber: res.data.data.userPhone, customerCode: res.data.data.userCode, userId: res.data.data.id, userName: res.data.data.userName };
                let sesssiondata = Object.assign(res.data.data, {
                  phoneNumber: res.data.data.userPhone,
                  customerCode: res.data.data.userCode,
                  userId: res.data.data.id,
                });
                sessionStorage.setItem(
                  "userInfoView",
                  JSON.stringify(sesssiondata)
                );
                sessionStorage.setItem(
                  "userInfo",
                  JSON.stringify(sesssiondata)
                );
              }
            })
            .catch((error) => {
              const userInfoView =
                window.sessionStorage.getItem("userInfoView");
              if (
                userInfoView &&
                userInfoView !== undefined &&
                userInfoView.indexOf("<!DOCTYPE html>") !== -1
              ) {
                next();
              } else {
                var userUrl = res.data.routAddress;
                var loginUrl = "";
                menuqueryaddressid({
                  name: "统一登录域名",
                  sign: "1",
                }).then((res) => {
                  loginUrl = res.data.routAddress;
                  let iframeEle = document.createElement("iframe");

                  iframeEle.src = loginUrl + "?service=" + userUrl;
                  iframeEle.style.width = "0px";
                  iframeEle.style.height = "0px";
                  iframeEle.onload = function () {
                    getUserInfo(userUrl)
                      .then((res) => {
                        if (res.status == 2000) {
                          self.$store.dispatch("saveUser", res.data);
                          // let sesssiondata = { phoneNumber: res.data.data.userPhone, customerCode: res.data.data.userCode, userId: res.data.data.id, userName: res.data.data.userName };
                          let sesssiondata = Object.assign(res.data.data, {
                            phoneNumber: res.data.data.userPhone,
                            customerCode: res.data.data.userCode,
                            userId: res.data.data.id,
                          });
                          sessionStorage.setItem(
                            "userInfoView",
                            JSON.stringify(sesssiondata)
                          );
                          sessionStorage.setItem(
                            "userInfo",
                            JSON.stringify(sesssiondata)
                          );
                        }
                      })
                      .catch(() => {
                        // self.next();
                      });
                  };
                  document.body.appendChild(iframeEle);
                });
              }
            });
        }
      });
    },
  },
};
</script>
<style scoped lang="scss"></style>
